/**
 * Fetch any data needed before navigating to a specific tab.
 * Example: the orders count for the Offers tab counter
 *
 */

import { type CommonQueryArgs } from '@pkg/hooks';

import { useFetchOrders } from './useOrders';

export function useFetchPortfolioData({ disabled }: CommonQueryArgs) {
    return useFetchOrders({ disabled });
}
